import Switch from "./switch.atom";

export default Switch;
